import { render, staticRenderFns } from "./DetailServicePiping.vue?vue&type=template&id=2ca7e860&"
import script from "./DetailServicePiping.vue?vue&type=script&lang=js&"
export * from "./DetailServicePiping.vue?vue&type=script&lang=js&"
import style0 from "./DetailServicePiping.vue?vue&type=style&index=0&id=2ca7e860&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports